import React, { useState, useEffect } from 'react';
import { Table, Button, Drawer, TableProps, Badge, HelpPanel, SplitPanel, CopyToClipboard, KeyValuePairs } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import Link from '@cloudscape-design/components/link';
import SpaceBetween from '@cloudscape-design/components/space-between';
import TextFilter from '@cloudscape-design/components/text-filter';
import Pagination from '@cloudscape-design/components/pagination';
import { CustomAppLayout } from '../../layout';
import { useRouter } from '../../router';
import { useStore } from '../../store';
import Box from '@cloudscape-design/components/box';
import CollectionPreferences from '@cloudscape-design/components/collection-preferences';
import ButtonDropdown from '@cloudscape-design/components/button-dropdown';
import { useGlobalState } from '../../../context/GlobalStateContext';
import { formatPhone, storeJWT } from '../../../commons/functions'; // Import the function

import {
  PhoneNumberUtil,
} from 'google-libphonenumber';
import { useStoreAdmin } from '../../../context/useStoreAdmin';
import { Icon } from '@mdi/react';
import { mdiBoomGateOutline, mdiEmail, mdiHelpCircleOutline, mdiHomeVariantOutline, mdiPhone } from '@mdi/js';

const pageSize = 30;

type UserItem = {
  displayName: string;
  nombre: string;
  apellido: string;
  movil: string;
  unidad: string;
  accesos: number;
  idControl: string;
  appBuilt: string;
  appVersion: string;
  idAutorizado: number;
  ultimoAcceso: string;
};

export const UsersListPage = () => {
  const storeAdmin = useStoreAdmin();
  const { idPropiedad, setIdPropiedad } = useGlobalState();
  const { JWT, setJWT } = useGlobalState(); const { serverVersion, setServerVersion } = useGlobalState(); const { menu, setMenu } = useGlobalState();
  const [sortingColumn, setSortingColumn] = useState({
    sortingField: 'displayName',
    isDescending: false,
  });
  const [isDescending, setIsDescending] = useState<boolean>(false); // Remove this line
  const [selectedRow, setSelectedRow] = useState<any>(null);  // Stores selected row data

  const [helpOpen, setHelpOpen] = useState(false);
  const [sideOpen, setSideOpen] = useState(false);

  const {
    actions: { makeHelpPanelHandler },
  } = useStore();
  const { navigate } = useRouter();
  const [selectedItems, setSelectedItems] = useState<UserItem[]>([]);
  const { setLoading } = useGlobalState();
  const [btnActionDisable, setBtnActionDisable] = useState<boolean>(true);
  const [users, setUsers] = useState<UserItem[]>([]);
  const [currentPageIndex, setCurrentPageIndex] = useState(1);
  const [filteringText, setFilteringText] = useState('');
  const filteredUsers = (users ?? []).filter(user => {
    const searchWords = filteringText.toLowerCase().split(/\s+/).filter(Boolean);
    return searchWords.every(word =>
      user.displayName?.toLowerCase().includes(word) ||
      user.movil?.toLowerCase().includes(word) ||
      user.appBuilt?.toLowerCase().includes(word) ||
      user.appVersion?.toLowerCase().includes(word) ||
      user.unidad?.toLowerCase().includes(word)
    );
  });


  type SortableFields = keyof UserItem;

  const field = sortingColumn.sortingField as SortableFields;

  const sortedUsers = [...filteredUsers].sort((a, b) => {
    const aValue = a[field]?.toString().toLowerCase() ?? "";
    const bValue = b[field]?.toString().toLowerCase() ?? "";

    if (aValue < bValue) return sortingColumn.isDescending ? 1 : -1;
    if (aValue > bValue) return sortingColumn.isDescending ? -1 : 1;
    return 0;
  });

  const paginatedUsers = sortedUsers.slice(
    (currentPageIndex - 1) * pageSize,
    currentPageIndex * pageSize
  );

  /*
  const paginatedUsers = filteredUsers.slice(
    (currentPageIndex - 1) * pageSize,
    currentPageIndex * pageSize
  );
*/
  const handleOnConfirm = ({ detail }: any) => {

  }
  const handleSelectionChange = ({ detail }: any) => {
    setSelectedItems(detail.selectedItems);
    setBtnActionDisable(detail.selectedItems.length === 0);
    if (detail.selectedItems.length > 1) requestAnimationFrame(() => setSideOpen(false));
  };

  // Handle row click to fetch additional data and open the HelpPanel
  const handleRowClick = async (rowData: any) => {

    //setSelectedRow(rowData);  // Store selected row data
    try {
      // Simulate a fetch request to get additional data for the row
      // Example of a fetched data structure
      const userDetails = {
        displayName: rowData.displayName,
        unidad: rowData.unidad,
        accesos: rowData.accesos,
        email: rowData.email,
        movil: rowData.movil,
        appVersion: rowData.appVersion,
        appBuilt: rowData.appBuilt,
      };
      // Set this data to be displayed in the HelpPanel
      setSelectedRow(userDetails);
      requestAnimationFrame(() => {
        requestAnimationFrame(() => setSideOpen(true));
      });
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      //setTimeout(() => setDrawerOpen(true), 200); 
    }
  };

  const handleRefresh = async () => {
    try {
      setLoading(true)
      const response = await fetch('https://api2.llavemovil.com/routing/v1/default.aspx', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/admin/users/list',
          'JWT': JWT,

        },
        body: JSON.stringify({})
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.json();


      storeAdmin(data);
      setUsers(data.users)
    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleRefresh();
  }, []);

  const phoneUtil = PhoneNumberUtil.getInstance();

  type SortingColumn = {
    sortingField: keyof UserItem;  // This should map to the keys of UserUnit
    isDescending: boolean;
  };
  type SortingChangeHandler = TableProps<UserItem>['onSortingChange'];

  const handleSortingChange: SortingChangeHandler = (event) => {
    const { sortingColumn: eventSortingColumn, isDescending: eventIsDescending } = event.detail;

    setSortingColumn((prevSortingColumn) => ({
      sortingField: eventSortingColumn?.sortingField || 'unidad',
      isDescending:
        prevSortingColumn.sortingField === eventSortingColumn?.sortingField
          ? !prevSortingColumn.isDescending
          : false, // Default to ascending when a new column is clicked
    }));
    // your logic
  };

  return (
    <CustomAppLayout
      toolsOpen={helpOpen}
      onToolsChange={({ detail }) => setHelpOpen(detail.open)}
      splitPanelOpen={sideOpen}
      onSplitPanelToggle={({ detail }) => setSideOpen(detail.open)}
      splitPanel={
        selectedRow && (
          <SplitPanel hidePreferencesButton header={selectedRow.displayName} closeBehavior='hide'>
            <KeyValuePairs
              columns={2}
              items={[
                {
                  label: <span><Icon path={mdiPhone} size={0.7} /> Móvil</span>,
                  value: formatPhone(selectedRow.movil),
                },
                {
                  label: <span><Icon path={mdiBoomGateOutline} size={0.7} /> Accesos</span>,
                  value: selectedRow.accesos,
                },
                {
                  label: <span><Icon path={mdiEmail} size={0.7} /> Email</span>,
                  value: selectedRow.email,
                },
                {
                  label: <span><Icon path={mdiHomeVariantOutline} size={0.7} /> Unidad</span>,
                  value: selectedRow.unidad,
                },
                {
                  label: "Versión",
                  value: `${selectedRow.appVersion}  ${selectedRow.appBuilt}`,
                },
              ]}
            />
          </SplitPanel>
        )
      }

      tools={
        helpOpen && (
          <HelpPanel
            header={
              <Header variant="h2">Ayuda</Header>
            }
          ><p>Listado total de usuarios que poseen al menos un acceso registrado con su propiedad</p>

            <p>Para eliminar uno o más accesos a un usuario o si desea modificar la unidad asociada al usuario, haga click sobre el número telefónico para editar los accesos/unidad del usuario.</p>

          </HelpPanel>
        )
      }
      contentType="form"
      breadcrumbs={<BreadcrumbGroup
        items={[
          { text: 'Inicio', href: '#home' },
          { text: 'Usuarios', href: '#users' },
          { text: 'Listar usuarios', href: '#create-transcription-job' },
        ]}
        expandAriaLabel="Show path"
        ariaLabel="Breadcrumbs" />}
      content={<>
        <Table
          stripedRows
          stickyHeader
          sortingColumn={sortingColumn} // Pass sortingColumn directly
          sortingDescending={sortingColumn.isDescending} // Pass isDescending directly from state
          onSortingChange={handleSortingChange} // Pass onSortingChange directly
          renderAriaLive={({ firstIndex, lastIndex, totalItemsCount }) => `Displaying items ${firstIndex} to ${lastIndex} of ${totalItemsCount}`}
          onSelectionChange={handleSelectionChange}
          selectedItems={selectedItems}
          onRowClick={({ detail }) => handleRowClick(detail.item)}
          ariaLabels={{
            selectionGroupLabel: "Items selection",
            allItemsSelectionLabel: () => "select all",
            itemSelectionLabel: ({ selectedItems }, item) => item.idControl,
          }}
          columnDefinitions={[
            {
              id: "movil",
              header: "Móvil",
              cell: (item) => (
                <Link href={`#users/edit?id=${item.idControl}`}>
                  {formatPhone(item.movil)}
                </Link>
              ),
              sortingField: "movil",
              isRowHeader: true,
            },
            {
              id: "displayName",
              header: "Usuario",
              cell: (item) => item.displayName,
              sortingField: "apellido",
            },
            {
              id: "unidad",
              header: "Unidad",
              cell: (item) => item.unidad,
              sortingField: "unidad",
            },
            {
              id: "accesos",
              header: "Accesos",
              cell: (item) => item.accesos,

            },
            {
              id: "appBuilt",
              header: "Ver",
              cell: (item) => item.appBuilt,
              sortingField: "appBuilt",

            },
            {
              id: "ultimoAcceso",
              header: "Últ Acc",
              cell: (item) => item.ultimoAcceso,
              sortingField: "ultimoAcceso",

            },
          ]}
          items={paginatedUsers}
          selectionType="multi"
          trackBy="idControl"
          empty={<Box margin={{ vertical: "xs" }} textAlign="center" color="inherit">
            <SpaceBetween size="m">
              <b>No tiene usuarios registrados</b>
              <Button href='#users/add'>Crear usuario</Button>
            </SpaceBetween>
          </Box>}
          filter={<TextFilter
            filteringText={filteringText}
            onChange={({ detail }) => {
              setFilteringText(detail.filteringText);
              setCurrentPageIndex(1);
            }} />}

          pagination={
            filteredUsers.length > pageSize && (
              <Pagination
                currentPageIndex={currentPageIndex}
                pagesCount={Math.ceil(filteredUsers.length / pageSize)}
                onChange={({ detail }) => setCurrentPageIndex(detail.currentPageIndex)} />
            )}
          header={<Header
            counter={
              selectedItems.length
                ? "(" + selectedItems.length + "/" + pageSize + ")"
                : ""
            }
            info={<Link onClick={() => setHelpOpen(!helpOpen)}><Icon path={mdiHelpCircleOutline} size={1}></Icon></Link>}
            actions={<SpaceBetween direction="horizontal" size="xs">
              <ButtonDropdown
                items={[
                  {
                    text: "Modificar unidad",
                    id: "delete",
                    disabled: false
                  },
                  {
                    text: "Eliminar Accesos",
                    id: "delete",
                    disabled: false
                  },
                ]}
                disabled={btnActionDisable}
              >
                Acciones
              </ButtonDropdown>
              <Button variant="primary" href='#users/add'>
                Agregar Usuario
              </Button>
            </SpaceBetween>}
          >Usuarios autorizados

          </Header>
          }
        ></Table>

      </>
      }
    />
  );
};

